// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactUpdateEffect from "./ReactUpdateEffect.res.js";

function use(value, delay) {
  let match = React.useState(() => value);
  let setDebouncedValue = match[1];
  ReactUpdateEffect.use1(() => {
    let handlerId = setTimeout(() => setDebouncedValue(param => value), delay);
    return () => {
      clearTimeout(handlerId);
    };
  }, [value]);
  return match[0];
}

export {
  use,
}
/* react Not a pure module */
